import { styled } from "@100mslive/react-ui";
import React from "react";
import SidePane from "../../layouts/SidePane";
import PreviewJoin from "./PreviewJoin";

const PreviewContainer = ({
  token,
  onJoin,
  env,
  skipPreview,
  initialName,
  asRole,
  type,
}) => {
  return (
    <Container>
      <PreviewJoin
        initialName={initialName}
        skipPreview={skipPreview}
        env={env}
        onJoin={onJoin}
        token={token}
        asRole={asRole}
        type={type}
      />
      <SidePane />
    </Container>
  );
};

const Container = styled("div", {
  width: "100%",
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "center",
  flexDirection: "column",
});

export default PreviewContainer;
